import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Row, Col, Drawer, Form,
} from 'antd';
import { EditOutlined } from '@ant-design/icons';

import FormVariableTextInput from '../../../forms/FormWorkflows/selectors/FormVariableTextInput';

import BorderlessButton from '../../buttons/BorderlessButton';
import DrawerSubmitFooter from '../../containers/DrawerSubmitFooter';

const allowedFieldTypes = new Set([
  'text',
  'attribute',
  'dateTime',
]);

function PDFDesignerNameInput({
  onTextChange,
  text,
  isDisplay,
  sections = [],
}) {
  const [currentText, setCurrentText] = useState(text);
  const [showDrawer, setShowDrawer] = useState(false);

  const openDrawer = useCallback(() => setShowDrawer(true), []);
  const onCloseDrawer = useCallback(() => {
    setShowDrawer(false);
    setCurrentText(text);
  }, [text]);

  const onSubmit = useCallback(() => {
    onTextChange(currentText);
    setShowDrawer(false);
  }, [currentText]);

  const fields = useMemo(() => {
    const relevantFields = [];
    sections?.forEach(({ fields: sectionFields = [], name: sectionName }) => {
      sectionFields?.forEach((field) => {
        const { selectedType, configProps: { title } = {} } = field;
        if (allowedFieldTypes.has(selectedType)) {
          relevantFields.push({
            key: `${sectionName} - ${title}`,
            name: `${sectionName} - ${title}`,
          });
        }
      });
    });
    return relevantFields;
  }, [sections]);

  return (
    <>
      <Row
        gutter={10}
        align="top"
        style={{
          position: 'absolute',
          top: isDisplay ? 105 : 115,
          height: 30,
          width: '100%',
        }}
      >
        <Col style={{ maxWidth: 'calc(100% - 90px)' }}>
          {`File Name: ${text}.pdf`}
        </Col>
        <Col style={{ width: 25, marginTop: -5 }}>
          {
            !isDisplay && (
              <BorderlessButton
                iconNode={<EditOutlined />}
                onClick={openDrawer}
              />
            )
          }
        </Col>
      </Row>
      <Form.Item
        name="pdfName"
      />
      <Drawer
        title="Configure PDF Name"
        visible={showDrawer}
        onClose={onCloseDrawer}
        width={400}
      >
        <FormVariableTextInput
          textAreaProps={{
            defaultValue: text,
          }}
          onTextChange={setCurrentText}
          text={currentText}
          visible={showDrawer}
          additionalVariables={fields}
        />
        <DrawerSubmitFooter
          onClose={onCloseDrawer}
          onSubmit={onSubmit}
          canSubmit={currentText?.length > 0}
        />
      </Drawer>
    </>
  );
}

PDFDesignerNameInput.propTypes = {
  onTextChange: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  isDisplay: PropTypes.bool,
  formRef: PropTypes.shape({
    current: PropTypes.shape({
      getFieldsValue: PropTypes.func,
      setFieldsValue: PropTypes.func,
    }),
  }).isRequired,
  sections: PropTypes.arrayOf(PropTypes.shape({})),
};

PDFDesignerNameInput.defaultProps = {
  isDisplay: false,
  sections: [],
};

export default PDFDesignerNameInput;
